import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import App from './navComponents/Common/App';
import ErrorBoundary from './navComponents/Common/ErrorBoundary';
import {ApolloProvider} from 'react-apollo';
import {ApolloLink, split} from "apollo-link";
import {onError} from "apollo-link-error";
import {InMemoryCache} from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import FirebaseProvider from './auth/firebaseContext';
import {getToken} from "./auth/token";
import {signOut} from "./auth/utils";
import {WebSocketLink} from "apollo-link-ws";
import {getMainDefinition} from "apollo-utilities";
import {createUploadLink} from "apollo-upload-client";
import {notify} from "./utils/notify";

if (process.env.NODE_ENV !== 'production') {
    localStorage.setItem('debug', 'junctionbox:*');
}

const theme = createMuiTheme({
        typography: {
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            body1: {
                color: "black"
            }
        },
        palette: {
            primary: {
                main: '#108FC0'
            },
            secondary: {
                main: '#1099AB'
            }
        }
    },
);

const uploadLink = createUploadLink({
    uri: process.env.REACT_APP_GRAPHQL_HTTP_PROTOCOL + '://' + process.env.REACT_APP_GRAPHQL_HOST + ':' + process.env.REACT_APP_GRAPHQL_HTTP_PORT + '/graphql'
});

const wsLink = new WebSocketLink({
    uri: process.env.REACT_APP_GRAPHQL_WS_PROTOCOL + '://' + process.env.REACT_APP_GRAPHQL_HOST + ':' + process.env.REACT_APP_GRAPHQL_HTTP_PORT + '/graphql',
    options: {
        reconnect: true,
    },
});

const terminatingLink = split(
    ({query}) => {
        const {kind, operation} = getMainDefinition(query);
        return (
            kind === 'OperationDefinition' && operation === 'subscription'
        );
    },
    wsLink,
    uploadLink,
    // httpLink,
);

const authLink = new ApolloLink((operation, forward) => {
    operation.setContext(({headers = {}}) => {
        const token = getToken();
        if (token) {
            headers = {...headers, 'x-token': token};
        }
        return {headers};
    });

    return forward(operation);
});

let ignoreErrors = false;
const errorLink = onError(({graphQLErrors, networkError, response, operation}) => {
    if (operation.operationName === "IgnoreErrorsQuery") {
        response.errors = null;
    }

    if (!ignoreErrors && graphQLErrors) {
        graphQLErrors.map(({message, locations, path, extensions}) => {
                if (extensions.code === 'UNAUTHENTICATED' || message === "Cannot read property 'userId' of null") {
                    if (window.location.pathname.indexOf('/sign-') === -1) localStorage.setItem('redirectPage', JSON.stringify(window.location.pathname + window.location.search));
                    ignoreErrors = true;
                    signOut();
                    console.log('## SVR index ## changing history', '/sign-in');
                    window.location = '/sign-in'
                } else {
                    console.log(
                        `## SVR index ## [GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}, ${extensions.code}, Extensions: ${extensions}`,
                    );
                    if (document.location.pathname.indexOf('/network-error') === -1) window.location = '/network-error'
                }
                return message;
            },
        );
    }

    if (!ignoreErrors && networkError) {
        localStorage.setItem('lastPage', JSON.stringify(window.location.href));
        console.log(`## SVR index ## [Network error]: ${networkError}`);
        // console.log(`## SVR index ## [Network error]: ${networkError}  \n operation - ${JSON.stringify(operation)} \n and response was ${response}`);
        notify('networkError', 'error', 'Some kind of network error!  Damn!  Please try again shortly.  Or Send Feedback please!');
    }
});

const link = ApolloLink.from([authLink, errorLink, terminatingLink]);

const cache = new InMemoryCache();

const client = new ApolloClient({
    link,
    cache,
    // clientState: {defaults: {}, resolvers: {}}
});

ReactDOM.render(
    <ErrorBoundary>
        <MuiThemeProvider theme={theme}>
            <ApolloProvider client={client}>
                <FirebaseProvider>
                    <App/>
                </FirebaseProvider>
            </ApolloProvider>
        </MuiThemeProvider>
    </ErrorBoundary>,
    document.getElementById('root')
);

serviceWorker.unregister();
